// extracted by mini-css-extract-plugin
export default {"alert":"ActionAlert-module__alert__5AAUt"};